// Template.Id — branded template identifier.
export { from, mk, to };
import { mkParser } from "../_ids/parse.js";
const mk = (s) => s;
const to = mkParser("TemplateId", mk);
const from = (id) => id;
//# sourceMappingURL=id.js.map